import script from "./CustomTextarea.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomTextarea.vue?vue&type=script&lang=ts&setup=true"

import "./CustomTextarea.vue?vue&type=style&index=0&id=cdb58a1e&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cdb58a1e"]])

export default __exports__